// type和初始值initialState
export interface ICommentList {
    isLoading: boolean;
    commentList: any[];
    pagination: Record<string, any>;
    errors: Record<string, any>;
}

export type State = ICommentList;

export type Action = {
    // getCommentList(id, data, visitor_id = '', hLang, hSiteId) => void;
    getCommentPhotoList: (
        id: number,
        data: Record<string, any>,
        visitor_id?: string,
    ) => Promise<void>;
    // getCommentDetailFun(id, data, visitor_id = '', hLang, hSiteId) => void;
};
export type CommentListAction = State & Action;

export const initialState: State = {
    isLoading: false,
    commentList: [],
    pagination: {},
    errors: {},
};
